import { render } from "./HomeView.vue?vue&type=template&id=825027e0&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=825027e0&scoped=true&lang=css"

import exportComponent from "/builds/unifybusiness/pics/games/arcade-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-825027e0"]])

export default __exports__